<template lang="pug">
  div.analise(v-if="dadosCadastro")
      div.rowVoltar
        el-button(type="success", @click="voltarNovoCadastro").btnVoltar
          i.fa.fa-chevron-left
        h2 Novo Cadastro
      el-steps(:active='activeStep', finish-status='success', simple)
        el-step(
          v-for="(step, index) in steps"
          :key="index"
          :title="step"
          :finish-status="index < activeStep ? 'success' : (index === activeStep ? 'process' : 'wait')"
        )
      div.content
          div(v-if="activeStep === 0")
            el-card(shadow="hover").card-collapse
              app-formulario-informacoes-Administrativas(
                :informacoes="dadosCadastro.informacoesAdministrativasUc"
                @update:informacoes="dadosCadastro.informacoesAdministrativasUc = $event"
              )
          div(v-if="activeStep === 1")
            el-card(shadow="hover").card-collapse
              app-formulario-atos-legais(
                :atos="dadosCadastro.atosLegais"
                @update:atos="dadosCadastro.atosLegais = $event"
              )
          div(v-if="activeStep === 2")
            el-card(shadow="hover").card-collapse
              app-formulario-contatos(
                :contato="dadosCadastro.contato"
                @update:contato="dadosCadastro.contato = $event",
                @update-emails="(event) => dadosCadastro.contato.emails = event",
                @update-telefones="(event) => dadosCadastro.contato.telefones = event"
              )
          div(v-if="activeStep === 3")
            el-card(shadow="hover").card-collapse
              app-formulario-localizacao(
                :localizacao="dadosCadastro.localizacao"
                @update:localizacao="dadosCadastro.localizacao = $event"
              )
      app-buttons-cadastro(
        :isUltimoPasso="activeStep === 3",
        :isPrimeiroPasso="activeStep === 0",
        :showButtonProximo="activeStep < steps.length - 1",
        :showButtonSalvar="activeStep < steps.length - 1"
        :showButtonVoltar="activeStep > 0",
        :showButtonFinalizar="activeStep === 3"
        @salvar="salvarDadosCadastro"
        @finalizar="finalizarDadosCadastro",
        @proximo="proximo",
        @voltar="voltar"
        @cancelar="cancelar",
        )
</template>
<script>
import { mapActions } from 'vuex'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppAnexo from '@/components/AppAnexo'
import AppFormularioInformacoesAdministrativas from './AppFormularioInformacoesAdministrativas.vue'
import AppFormularioAtosLegais from './AppFormularioAtosLegais.vue'
import AppFormularioContatos from './AppFormularioContatos.vue'
import AppLabel from '@/components/AppLabel'
import AppFormularioLocalizacao from './AppFormularioLocalizacao.vue'

export default {
  components: {
    AppButtonsCadastro,
    AppLabel,
    AppAnexo,
    AppFormularioInformacoesAdministrativas,
    AppFormularioAtosLegais,
    AppFormularioContatos,
    AppFormularioLocalizacao
  },

  mixins: [AppNotificacao],

  data () {
    return {
      active: 0,
      activeStep: 0,
      steps: ['Informações Administrativas da UC', 'Atos Legais', 'Contatos', 'Localização'],
      dadosCadastro: null
    }
  },
  async mounted () {
    this.dadosCadastro = await this.cadastroUcById(this.$route.params.id)
    this.dadosCadastro.localizacao.geometrias = this.dadosCadastro.localizacao.geometrias.map(j => JSON.parse(j))
    this.formatAllDocumentosAnalise(this.dadosCadastro.atosLegais)
  },
  methods: {
    ...mapActions({
      cadastroUcFinalizar: 'cadastroUc/cadastroUcFinalizar',
      cadastroUcSalvar: 'cadastroUc/cadastroUcSalvar',
      cadastroUcById: 'cadastroUc/cadastroUcById'
    }),
    async proximo () {
      if (this.activeStep < this.steps.length - 1) {
        await this.salvarDadosCadastro()
        this.activeStep++
      }
    },
    voltar () {
      if (this.activeStep > 0) {
        this.activeStep--
      }
    },
    async finalizarDadosCadastro () {
      const informacoesUcDto = {
        id: this.$route.params.id,
        informacoesAdministrativasUc: this.dadosCadastro.informacoesAdministrativasUc,
        atosLegais: this.dadosCadastro.atosLegais,
        contato: this.dadosCadastro.contato,
        localizacao: this.dadosCadastro.localizacao
      }

      try {
        const atosLegaisAux = {...informacoesUcDto.atosLegais}
        this.formatAllDocumentosJson(this.formatAllDocumentosJson(informacoesUcDto.atosLegais))
        await this.cadastroUcFinalizar(informacoesUcDto)
        informacoesUcDto.atosLegais = atosLegaisAux
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CADASTRO_UC_SUCESSO
        )

        this.$router.push({
          name: 'CADASTROS_EM_ANDAMENTO_UC'
        })
      } catch (error) {
        console.error('Erro ao realizar o cadastro:', error)

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CADASTRO_UC_ERRO
        )
      }
    },
    async salvarDadosCadastro () {
      const informacoesUcDto = {
        id: this.$route.params.id,
        informacoesAdministrativasUc: this.dadosCadastro.informacoesAdministrativasUc,
        atosLegais: this.dadosCadastro.atosLegais,
        contato: this.dadosCadastro.contato,
        localizacao: this.dadosCadastro.localizacao
      }

      try {
        const atosLegaisAux = {...informacoesUcDto.atosLegais}
        this.formatAllDocumentosJson(this.formatAllDocumentosJson(informacoesUcDto.atosLegais))
        await this.cadastroUcSalvar(informacoesUcDto)
        informacoesUcDto.atosLegais = atosLegaisAux
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CADASTRO_UC_SALVAR_SUCESSO
        )
      } catch (error) {
        console.error(error)

        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CADASTRO_UC_SALVAR_ERRO
        )
      }
    },
    cancelar () {
      this.confirmBox(
        `Tem certeza que deseja cancelar? Seus dados não serão salvos`,
        this.$messages.TITULO_WARNING,
        () => {
          this.$router.back()
        },
        () => {}
      )
    },
    voltarNovoCadastro () {
      this.$router.back()
    },
    formatAllDocumentosJson (atosLegais) {
      if (atosLegais) {
        atosLegais.anexoAtoLegal = this.formataDocumentoJson(atosLegais?.anexoAtoLegal)
        atosLegais.anexoPlanoManejo = this.formataDocumentoJson(atosLegais?.anexoPlanoManejo)
        atosLegais.anexoPlanoManejoAtoLegal = this.formataDocumentoJson(atosLegais?.anexoPlanoManejoAtoLegal)
        atosLegais.anexoDocumentoConselho = this.formataDocumentoJson(atosLegais?.anexoDocumentoConselho)
        atosLegais.anexoInstrumentoGestao = this.formataDocumentoJson(atosLegais?.anexoInstrumentoGestao)
        atosLegais.anexoInstrumentoGestaoAtoLegal = this.formataDocumentoJson(atosLegais?.anexoInstrumentoGestaoAtoLegal)
      }
    },
    formatAllDocumentosAnalise (atosLegais) {
      if (atosLegais) {
        atosLegais.anexoAtoLegal = this.formataDocumentoAnalise(atosLegais?.anexoAtoLegal)
        atosLegais.anexoPlanoManejo = this.formataDocumentoAnalise(atosLegais?.anexoPlanoManejo)
        atosLegais.anexoPlanoManejoAtoLegal = this.formataDocumentoAnalise(atosLegais?.anexoPlanoManejoAtoLegal)
        atosLegais.anexoDocumentoConselho = this.formataDocumentoAnalise(atosLegais?.anexoDocumentoConselho)
        atosLegais.anexoInstrumentoGestao = this.formataDocumentoAnalise(atosLegais?.anexoInstrumentoGestao)
        atosLegais.anexoInstrumentoGestaoAtoLegal = this.formataDocumentoAnalise(atosLegais?.anexoInstrumentoGestaoAtoLegal)
      }
    },
    formataDocumentoAnalise (documento) {
      if (!documento) {
        return null
      }
      return {
        id: documento.id,
        fileKey: documento.fileKey || documento.key,
        fileName: documento.fileName || documento.nome,
        caminho: documento.caminho,
        tipoDocumento: {
          codigo: documento.tipo.codigo,
          id: documento.tipo.id,
          descricao: documento.tipo.descricao,
          tipo: documento.tipo.codigo
        }
      }
    },
    formataDocumentoJson (documento) {
      if (!documento) {
        return null
      }
      return {
        id: documento.id,
        caminho: documento.caminho,
        key: documento.fileKey || documento.key,
        nome: documento.fileName || documento.nome,
        fileName: documento.fileName || documento.nome,
        tipo: documento.tipoDocumento || documento.tipo,
        fileKey: documento.fileKey || documento.key,
        tipoDocumento: documento.tipoDocumento || documento.tipo
      }
    }
  }
}

</script>
<style lang="scss">
.card-collapse {
    border-radius: 10px;
    margin: 10px 0;
  }
  .analise {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
.rowVoltar {
    display: flex;
    height: 50px;
    gap: 20px;
    align-items: center;
    margin-bottom: 10px;
  }
  .btnVoltar {
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppCadastroUC.vue